import React, { Fragment, useCallback } from 'react';
import { Transition, Menu } from '@headlessui/react';

export interface CustomDropdownProps {
  buttonElement?: JSX.Element;
  buttonClassNames?: (open?: boolean) => string | string;
  menuWrapperClassNames?: string;
  menuClassNames?: (open?: boolean) => string | string;
}

const CustomDropDown = ({
  buttonElement,
  buttonClassNames,
  menuWrapperClassNames,
  menuClassNames,
  children,
}: React.PropsWithChildren<CustomDropdownProps>) => {
  const defaultButtonClassNames = useCallback((open?: boolean) => {
    return `flex h-40 w-full items-center gap-8 justify-between  bg-inherit px-16 py-12`;
  }, []);

  const defaultMenuClassNames = useCallback((open?: boolean) => {
    return ` overflow-auto  bg-white`;
  }, []);

  return (
    <Menu as="div" className="relative">
      {({ open, close }) => (
        <>
          <Menu.Button as="div" className={buttonClassNames ? buttonClassNames(open) : defaultButtonClassNames(open)}>
            {buttonElement}
          </Menu.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform origin-top scale-y-0"
            enterTo="transform origin-top scale-y-100"
            leave="transition ease-in duration-100"
            leaveFrom="transform origin-top scale-y-150"
            leaveTo="transform origin-top scale-y-0"
          >
            <Menu.Items className={menuWrapperClassNames ?? 'absolute right-0 top-40 w-full focus:border-none'}>
              <div onClick={()=>close()} className={menuClassNames ? menuClassNames(open) : defaultMenuClassNames(open)}>{children}</div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default CustomDropDown;
